import { Configuration, LogLevel } from "@azure/msal-browser";
import { trackTrace, SeverityLevel } from "./telemetry/telemetryService";

/**
 * MSAL Configuration
 *
 * The clientId is injected at build time via the REACT_APP_CLIENT_ID
 * environment variable (set in env/dev.env and env/prod.env).
 *
 * authority     — https://login.microsoftonline.com/<YOUR_TENANT_ID>
 * redirectUri   — The URL where this app is hosted (e.g. http://localhost:3000)
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "ad8a9e55-96af-4018-93c6-3a12281b0750",
    authority: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47", // <-- Replace with your Tenant ID
    redirectUri: window.location.origin, // Auto-detects; works for localhost and production
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage", // Keeps user signed in across tabs/refreshes
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            trackTrace(message, SeverityLevel.Error, { source: "MSAL" });
            break;
          case LogLevel.Warning:
            trackTrace(message, SeverityLevel.Warning, { source: "MSAL" });
            break;
          default:
            break;
        }
      },
    },
  },
};

/**
 * Scopes requested during login.
 * "User.Read" is the minimum needed to read the signed-in user's profile.
 * Add more scopes here if your API requires them.
 */
export const loginRequest = {
  scopes: ["User.Read"],
};
